import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import Footer from "../components/Footer";
import Navbar from "../components/SpectraNavbar";
import FaqCons from "../constants/faq";
import "../styles/Faq.css";

const Faq = () => {
  return (
    <div className='flex-container faq-page'>
      <Navbar />
      <div className='flex-body mx-5'>
        <div className='full-height faq-body-inner'>
          <div className='px-sm-3 px-lg-5 py-3 full-height faq-content-wrap'>
            <div className='shadow card full-height'>
              <div className='card-body full-height d-flex flex-column'>
                <header className='mb-4'>
                  <h5 className='mb-1'>Frequently Asked Questions</h5>
                  <p className='text-muted fs-6'>
                    Answers to common questions about device set up, sample
                    preparation, testing procedure, and testing support
                  </p>
                </header>
                <Tabs
                  defaultActiveKey={FaqCons.CATEGORIES[0]?.key}
                  id='faq-category-tabs'
                  className='faq-category-tabs mb-3'
                >
                  {FaqCons.CATEGORIES.map((category) => {
                    const items = category.questions.map((q) => ({
                      key: q.key,
                      label: q.question,
                      children: (
                        <>
                          <div
                            className='faq-answer'
                            dangerouslySetInnerHTML={{ __html: q.answer }}
                          />
                          {q.images && q.images.length > 0 && (
                            <div className='faq-answer-images'>
                              {q.images.map((image) => (
                                <figure
                                  key={image.src}
                                  className='faq-answer-figure'
                                >
                                  <img
                                    src={image.src}
                                    alt={image.alt}
                                    className='faq-answer-image'
                                  />
                                  {image.caption && (
                                    <figcaption className='faq-answer-caption'>
                                      {image.caption}
                                    </figcaption>
                                  )}
                                </figure>
                              ))}
                            </div>
                          )}
                        </>
                      ),
                    }));

                    return (
                      <Tab
                        key={category.key}
                        eventKey={category.key}
                        title={category.title}
                      >
                        <Collapse
                          accordion
                          expandIconPosition='start'
                          ghost={true}
                          expandIcon={({ isActive }) => (
                            <CaretRightOutlined
                              rotate={isActive ? 90 : 0}
                              style={{ color: "#1CA3F0", fontSize: "16px" }}
                            />
                          )}
                          items={items}
                        />
                      </Tab>
                    );
                  })}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
